var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirtdaySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107,
    height: 75,
    viewBox: "0 0 107 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff201"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "birtday-small",
    transform: "translate(3881 -3498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13661",
    "data-name": "Path 13661",
    d: "M528.355,291.774V328.7H483.831V291.774H481.86v-9.929h48.467v9.929Z",
    transform: "translate(-4340.413 3240.794)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10093",
    "data-name": "Rectangle 10093",
    width: 17.307,
    height: 2.101,
    transform: "translate(-3856.482 3532.42)",
    fill: "#51bbe5",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13663",
    "data-name": "Path 13663",
    d: "M475.228,303.476c.794.229,6.945-.46,10.26-7.154l-3.229-3.355c-.348,2.577-.894,9.067-7.255,9.828Z",
    transform: "translate(-4341.24 3242.292)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13664",
    "data-name": "Path 13664",
    d: "M474.788,303.259c.736-3.9,2.426-8.851,8.271-11.147a29.075,29.075,0,0,1,2.461,4.334c-2.185-.553-7.622.583-10.26,7.154Z",
    transform: "translate(-4341.271 3242.166)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13665",
    "data-name": "Path 13665",
    d: "M466.828,295.49c.144,2.378.529,4.35,2.112,5.364a18.894,18.894,0,0,0,7.8,2.585l.148-.345c-1.126-.35-5.431-2.749-6-3.913a6.007,6.007,0,0,1-.228-4.9Z",
    transform: "translate(-4342.304 3242.486)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13666",
    "data-name": "Path 13666",
    d: "M476.956,303.673c.259-4.248-3.017-9.873-7.625-11.615l-2.5,3.754c2.49.271,9.284,3.332,9.915,7.949Z",
    transform: "translate(-4342.304 3242.158)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10094",
    "data-name": "Rectangle 10094",
    width: 19.984,
    height: 23.04,
    transform: "translate(-3873.302 3544.672)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10095",
    "data-name": "Rectangle 10095",
    width: 21.501,
    height: 4.528,
    transform: "translate(-3874.058 3544.059)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10096",
    "data-name": "Rectangle 10096",
    width: 18.622,
    height: 23.04,
    transform: "translate(-3880.294 3544.672)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10097",
    "data-name": "Rectangle 10097",
    width: 20.035,
    height: 4.528,
    transform: "translate(-3881 3544.059)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10098",
    "data-name": "Rectangle 10098",
    width: 8.455,
    height: 0.759,
    transform: "translate(-3861.846 3548.595)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10099",
    "data-name": "Rectangle 10099",
    width: 2.779,
    height: 23.556,
    transform: "translate(-3872.372 3544.155)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10100",
    "data-name": "Rectangle 10100",
    width: 1.772,
    height: 19.028,
    transform: "translate(-3858.514 3548.684)",
    fill: "#febf00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10101",
    "data-name": "Rectangle 10101",
    width: 1.772,
    height: 0.759,
    transform: "translate(-3858.514 3548.595)",
    fill: "#eaa700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10102",
    "data-name": "Rectangle 10102",
    width: 1.772,
    height: 4.528,
    transform: "translate(-3857.761 3544.059)",
    fill: "#febf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13667",
    "data-name": "Path 13667",
    d: "M491.708,278.989c5.172-.137,11.4,1.492,14.266,5.387l1.8-.186c-8.468-8.815-17.852-12.965-21.882-4.048a15.211,15.211,0,0,1,5.814-1.153",
    transform: "translate(-4339.784 3239.615)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13668",
    "data-name": "Path 13668",
    d: "M505.062,284.11c-5.619.557-13.459-4.7-13.354-5.605a15.211,15.211,0,0,0-5.814,1.153c5.524,5.52,12.26,6.319,19.26,5.927Z",
    transform: "translate(-4339.778 3240.113)",
    fill: "#66d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13669",
    "data-name": "Path 13669",
    d: "M533.1,279.154c-4.352-.134-9.589,1.45-12,5.234l-1.518-.181c7.125-8.564,15.02-12.6,18.412-3.933a11.338,11.338,0,0,0-4.892-1.12",
    transform: "translate(-4335.135 3239.656)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13670",
    "data-name": "Path 13670",
    d: "M521.582,284.128c4.727.542,11.323-4.569,11.235-5.445a11.338,11.338,0,0,1,4.892,1.12c-4.648,5.363-10.315,6.14-16.2,5.759Z",
    transform: "translate(-4334.859 3240.14)",
    fill: "#66d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10103",
    "data-name": "Rectangle 10103",
    width: 44.524,
    height: 45.809,
    transform: "translate(-3839.371 3523.685)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10104",
    "data-name": "Rectangle 10104",
    width: 44.524,
    height: 9.929,
    transform: "translate(-3839.371 3524.563)",
    fill: "#66d0ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10105",
    "data-name": "Rectangle 10105",
    width: 7.843,
    height: 9.929,
    transform: "translate(-3820.997 3524.563)",
    fill: "#66d0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10106",
    "data-name": "Rectangle 10106",
    width: 7.752,
    height: 34.836,
    transform: "translate(-3820.956 3534.658)",
    fill: "#81dcfc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10107",
    "data-name": "Rectangle 10107",
    width: 48.466,
    height: 9.929,
    transform: "translate(-3841.347 3522.464)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10108",
    "data-name": "Rectangle 10108",
    width: 7.752,
    height: 9.929,
    transform: "translate(-3820.956 3522.464)",
    fill: "#81dcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13671",
    "data-name": "Path 13671",
    d: "M502.947,273.245c4.308,1.5,8.586,5.256,8.977,10.416H514.4c.317-10.183-9.011-19.451-16.8-11.009a10.876,10.876,0,0,1,5.343.593",
    transform: "translate(-4338.158 3238.698)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13672",
    "data-name": "Path 13672",
    d: "M506.944,283.258c-6.306-2.128-4.5-9.465-3.961-10.416a10.876,10.876,0,0,0-5.343-.593c-.921,4.144.175,9.209,6.108,11.009Z",
    transform: "translate(-4338.172 3239.16)",
    fill: "#66d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13673",
    "data-name": "Path 13673",
    d: "M523.741,273.245c-4.307,1.5-8.584,5.256-8.976,10.416h-2.479c-.317-10.183,9.009-19.451,16.8-11.009a10.882,10.882,0,0,0-5.344.593",
    transform: "translate(-4336.134 3238.698)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13674",
    "data-name": "Path 13674",
    d: "M518.828,283.258c6.306-2.128,4.5-9.465,3.961-10.416a10.882,10.882,0,0,1,5.344-.593c.921,4.144-.176,9.209-6.108,11.009Z",
    transform: "translate(-4335.201 3239.16)",
    fill: "#66d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10109",
    "data-name": "Rectangle 10109",
    width: 4.505,
    height: 36.926,
    transform: "translate(-3850.095 3532.567)",
    fill: "#81dcfc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10110",
    "data-name": "Rectangle 10110",
    width: 17.367,
    height: 9.929,
    transform: "translate(-3858.47 3522.464)",
    fill: "#055fa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10111",
    "data-name": "Rectangle 10111",
    width: 4.505,
    height: 9.929,
    transform: "translate(-3852.055 3522.464)",
    fill: "#81dcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13675",
    "data-name": "Path 13675",
    d: "M532.674,277.637a4.38,4.38,0,0,0-.529-.125c.283-1.7.961-2.264,1.482-2.215a7.567,7.567,0,0,0-.953,2.34",
    transform: "translate(-4333.323 3239.627)",
    fill: "#d6fcfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10112",
    "data-name": "Rectangle 10112",
    width: 16.77,
    height: 16.862,
    transform: "translate(-3796.706 3553.93)",
    fill: "#febf00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10113",
    "data-name": "Rectangle 10113",
    width: 15.627,
    height: 16.862,
    transform: "translate(-3802.534 3553.93)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10114",
    "data-name": "Rectangle 10114",
    width: 2.332,
    height: 17.239,
    transform: "translate(-3795.84 3553.553)",
    fill: "#055fa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10115",
    "data-name": "Rectangle 10115",
    width: 2.332,
    height: 0.556,
    transform: "translate(-3795.84 3556.808)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10116",
    "data-name": "Rectangle 10116",
    width: 1.487,
    height: 13.925,
    transform: "translate(-3784.228 3556.866)",
    fill: "#055fa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10117",
    "data-name": "Rectangle 10117",
    width: 1.487,
    height: 0.556,
    transform: "translate(-3784.228 3556.808)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13676",
    "data-name": "Path 13676",
    d: "M541.562,310.917c.578.167,5.063-.337,7.479-5.235l-2.354-2.454c-.254,1.885-.652,6.635-5.288,7.192Z",
    transform: "translate(-4332.083 3243.826)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13677",
    "data-name": "Path 13677",
    d: "M541.241,310.758c.536-2.853,1.768-6.478,6.028-8.158a21.382,21.382,0,0,1,1.795,3.173c-1.593-.405-5.556.427-7.479,5.235Z",
    transform: "translate(-4332.106 3243.733)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13678",
    "data-name": "Path 13678",
    d: "M543.649,309.406l-.064-.187a5.78,5.78,0,0,0,5.458-2.891l.9,1.961c-1.078,1.166-2.629,2.356-6.3,1.117",
    transform: "translate(-4331.772 3244.278)",
    fill: "#004990",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13679",
    "data-name": "Path 13679",
    d: "M543.418,309.3l.255.135c2.656-1.112,3.663-1.6,6.32-1.1l-.857-2.175c-2.145.118-2.973.829-5.719,3.144",
    transform: "translate(-4331.796 3244.252)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13680",
    "data-name": "Path 13680",
    d: "M535.438,305.073c.105,1.741.386,3.184,1.541,3.925a13.717,13.717,0,0,0,5.687,1.892l.109-.252c-.821-.257-3.96-2.012-4.377-2.863a4.409,4.409,0,0,1-.166-3.588Z",
    transform: "translate(-4332.893 3243.967)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13681",
    "data-name": "Path 13681",
    d: "M542.821,311.062a9.392,9.392,0,0,0-5.557-8.5l-1.826,2.748c1.815.2,6.768,2.438,7.227,5.817Z",
    transform: "translate(-4332.893 3243.729)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10118",
    "data-name": "Rectangle 10118",
    width: 18.042,
    height: 3.314,
    transform: "translate(-3797.342 3553.489)",
    fill: "#febf00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10119",
    "data-name": "Rectangle 10119",
    width: 18.042,
    height: 0.608,
    transform: "translate(-3797.342 3556.197)",
    fill: "#febf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13682",
    "data-name": "Path 13682",
    d: "M539.63,309.406l.064-.187a5.781,5.781,0,0,1-5.458-2.891l-.9,1.961c1.078,1.166,2.629,2.356,6.3,1.117",
    transform: "translate(-4333.18 3244.278)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13683",
    "data-name": "Path 13683",
    d: "M539.89,309.3l-.257.135c-2.655-1.112-3.663-1.6-6.319-1.1l.857-2.175c2.144.118,2.972.829,5.719,3.144",
    transform: "translate(-4333.183 3244.252)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10120",
    "data-name": "Rectangle 10120",
    width: 16.813,
    height: 3.314,
    transform: "translate(-3803.128 3553.489)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10121",
    "data-name": "Rectangle 10121",
    width: 16.813,
    height: 0.608,
    transform: "translate(-3803.128 3556.197)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13684",
    "data-name": "Path 13684",
    d: "M542.7,308.835c-2,.328-4.914,4.034-5.014,7.653-.471-.291-2.963-2.309-3.255-2.482.777-1.8,4.063-4.962,7.605-5.171Z",
    transform: "translate(-4333.037 3244.668)",
    fill: "#7a3020",
    fillRule: "evenodd",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10122",
    "data-name": "Rectangle 10122",
    width: 1.487,
    height: 3.314,
    transform: "translate(-3783.591 3553.489)",
    fill: "#055fa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13685",
    "data-name": "Path 13685",
    d: "M542.845,308.835c-2.073.328-5.836,4.034-6.762,7.653-.4-.291-2.435-2.309-2.688-2.482,1.188-1.8,5.2-4.962,8.786-5.171Z",
    transform: "translate(-4333.185 3244.668)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13686",
    "data-name": "Path 13686",
    d: "M542.189,308.853c-1.716.186-3.221.628-4.737,3.314-.731-.121-1.536-.363-2.168-.522,1.818-3.261,4.419-3.067,6.905-2.791",
    transform: "translate(-4332.912 3244.636)",
    fill: "#0d3f68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13687",
    "data-name": "Path 13687",
    d: "M542.3,308.872a7.039,7.039,0,0,0-5.747,3.559c-.7-.121-1.947-.363-2.539-.522,2.655-3.261,6.049-3.771,8.287-3.036",
    transform: "translate(-4333.094 3244.617)",
    fill: "#055fa8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13688",
    "data-name": "Path 13688",
    d: "M506.458,323.173v3.618H500.18v-3.618Zm0-4.5v3.617H500.18v-3.617Zm0-4.5v3.617H500.18V314.17Zm0-4.5v3.618H500.18v-3.618Zm0-4.5v3.617H500.18v-3.617Zm0-4.5v3.617H500.18v-3.617Zm-6.278-.884v-3.618h6.278v3.618Zm0-6.579H499.3v37.354h.884v-2.881h6.278v2.881h.884V293.2h-.884v2.077H500.18Z",
    transform: "translate(-4337.899 3242.444)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13689",
    "data-name": "Path 13689",
    d: "M499.4,290.685a11.761,11.761,0,0,1,.391-4.246c-.22-.314.107-1.665.687-1.822.312-.069.195,1.119.166,1.206.168-.023.294-.43.325-.439s.125.337-.212.764c-.12.157-.45.346-.478.4a9.461,9.461,0,0,0,.329,3.545,7.779,7.779,0,0,0-1.208.592",
    transform: "translate(-4337.877 3241.028)",
    fill: "#faa098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13690",
    "data-name": "Path 13690",
    d: "M503.263,289.787a1.259,1.259,0,0,1,.182.685c0,.467-.207.853-.478.913-.019.107-.081.358-.081.358l-.71-.125s-.263-.465-.1-.566a2.579,2.579,0,0,1,.78-.326,1.667,1.667,0,0,1,.113.554.6.6,0,0,0,.128-.224c.025-.09-.076-.806-.056-.939.008-.058.121-.147.222-.33",
    transform: "translate(-4337.504 3241.797)",
    fill: "#faa098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13691",
    "data-name": "Path 13691",
    d: "M505.457,299.481c-.032-.566-.377-4.26-.523-5.5.538,1.307,1.661,2.6,2.511,2.4.651-.578-.9-3.6-1.689-4.564a7.346,7.346,0,0,0-3.938-.2c-.2-.359-.977-1.947-1.083-2.237a5.832,5.832,0,0,0-1.558.805,11.772,11.772,0,0,0,1.4,3.373c-.165,1.085-.489,5.013-.588,6.144a24.82,24.82,0,0,1,5.467-.213",
    transform: "translate(-4337.917 3241.751)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13692",
    "data-name": "Path 13692",
    d: "M500.857,306.37l.023.647a.839.839,0,0,0,.7,0v-.607Z",
    transform: "translate(-4337.665 3244.276)",
    fill: "#faa098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13693",
    "data-name": "Path 13693",
    d: "M501.015,306.861a5.581,5.581,0,0,0-1.116.865V308a14.184,14.184,0,0,0,1.971-.16v-.875l-.156-.143v.129a.839.839,0,0,1-.7,0Z",
    transform: "translate(-4337.801 3244.347)",
    fill: "#194294",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13694",
    "data-name": "Path 13694",
    d: "M504.217,310.283l.03.753a.679.679,0,0,1-.693,0l-.082-.7.726-.056Z",
    transform: "translate(-4337.302 3244.863)",
    fill: "#faa098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13695",
    "data-name": "Path 13695",
    d: "M504.282,310.854l-.019-.01,0,.11a.651.651,0,0,1-.058.029.6.6,0,0,0,.077-.037Zm-.718.008-.086.052-.15,1.038a.642.642,0,0,0,.592.139c.388-.08,1.449-.349,1.449-.349l-.084-.356-1-.53,0,.092a.6.6,0,0,1-.077.037.633.633,0,0,1-.635-.029Z",
    transform: "translate(-4337.325 3244.948)",
    fill: "#194294",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13696",
    "data-name": "Path 13696",
    d: "M506.341,293.628a2.216,2.216,0,0,0-1.644.787c.576.854,1.331,1.486,1.945,1.341.324-.289.1-1.183-.3-2.128",
    transform: "translate(-4337.135 3242.373)",
    fill: "#faa098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13697",
    "data-name": "Path 13697",
    d: "M499.961,298.407a40.535,40.535,0,0,0-.251,4.161c.071.908.731,3.24,1.076,5.218l.964-.006c.049-.94.921-2.749.326-4.642a1.426,1.426,0,0,0,.243-.413,19.487,19.487,0,0,1-.627-4.522,12.33,12.33,0,0,0-1.732.2",
    transform: "translate(-4337.829 3243.077)",
    fill: "#db8b29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13698",
    "data-name": "Path 13698",
    d: "M502.068,302.734a12.852,12.852,0,0,0,1.07,2.813c-1.317,1.763-.368,4.93.3,6.712l1.183-.011c-.057-2.774,1.077-7.745.5-14.039a23.328,23.328,0,0,0-3.687,0,19.487,19.487,0,0,0,.627,4.522",
    transform: "translate(-4337.591 3243.081)",
    fill: "#ffa12e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13699",
    "data-name": "Path 13699",
    d: "M501.81,291.963c.308-.038,1.231-.229,1.388-.748.025-.09-.076-.806-.056-.939a1.579,1.579,0,0,0,.3-1.583c-.4.6-1.187.164-1.784.735a2.216,2.216,0,0,0,.151,2.535",
    transform: "translate(-4337.602 3241.635)",
    fill: "#194294",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13700",
    "data-name": "Path 13700",
    d: "M544.128,299.7l-.188.735a.185.185,0,0,1-.08.118l.085-.334,0-.037c-.032-.213-.455-.591-.651-.723l.188-.735c.2.132.619.51.651.723a.671.671,0,0,1,0,.253",
    transform: "translate(-4331.794 3243.136)",
    fill: "#a1f1fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13701",
    "data-name": "Path 13701",
    d: "M516.031,317.015l.488.218a.13.13,0,0,1,.073.07l-.222-.1h-.026c-.152,0-.464.245-.578.365l-.488-.218c.115-.12.426-.369.578-.365a.492.492,0,0,1,.175.03",
    transform: "translate(-4335.664 3245.902)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13702",
    "data-name": "Path 13702",
    d: "M556.059,296.63l-1.135,1.136a1.506,1.506,0,0,1-.664.344l.911-.911a4.858,4.858,0,0,0-.048-.887l1.135-1.135c.065.628.14,1.114-.2,1.452",
    transform: "translate(-4330.313 3242.606)",
    fill: "#fd0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13703",
    "data-name": "Path 13703",
    d: "M508.54,299.536l-2.347,2.346a3.09,3.09,0,0,1-1.372.711l1.882-1.882a9.883,9.883,0,0,0-.1-1.831l2.346-2.346c.135,1.3.29,2.3-.409,3",
    transform: "translate(-4337.124 3242.816)",
    fill: "#e48603",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13705",
    "data-name": "Path 13705",
    d: "M496.637,275.669a1.069,1.069,0,0,1-.356.241l-1.988.719c-.483.174-.776-.4-1.148-.889l-1.82.659c.186-.539.278-1.146.654-1.282l1.988-.719a.75.75,0,0,1,.577.081c.607.284.917,1.263,1.412,1.436Z",
    transform: "translate(-4338.997 3239.488)",
    fill: "#b0fcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13706",
    "data-name": "Path 13706",
    d: "M516.527,279.172l.617.276a.167.167,0,0,1,.093.088l-.282-.125h-.032a1.625,1.625,0,0,0-.733.463l-.618-.276a1.635,1.635,0,0,1,.733-.463.648.648,0,0,1,.222.038",
    transform: "translate(-4335.625 3240.199)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13707",
    "data-name": "Path 13707",
    d: "M506.484,285.511l.772,1.292a1.4,1.4,0,0,1,.16.682l-.618-1.035a4.446,4.446,0,0,0-.817-.159L505.209,285c.585.085,1.045.127,1.275.513",
    transform: "translate(-4337.064 3241.08)",
    fill: "#fd0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13708",
    "data-name": "Path 13708",
    d: "M510.642,272.748a.807.807,0,0,1-.606-1.2l.856-1.538c.229-.411.865-.653,2.056-.141a1.129,1.129,0,0,0,.653.084l.647-1.165a1.25,1.25,0,0,1-.107.782l-.856,1.538a.906.906,0,0,1-1.193.3,3.594,3.594,0,0,0-.866-.266.693.693,0,0,0,.271.069Z",
    transform: "translate(-4336.415 3238.615)",
    fill: "#2451aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13709",
    "data-name": "Path 13709",
    d: "M533.791,310.425a.807.807,0,0,0,.252-1.322l-1.245-1.245c-.332-.333-1.01-.391-2.015.428a1.137,1.137,0,0,1-.6.26l-.943-.943a1.253,1.253,0,0,0,.317.722l1.245,1.245a.9.9,0,0,0,1.229-.039,3.69,3.69,0,0,1,.761-.492.718.718,0,0,1-.242.141Z",
    transform: "translate(-4333.742 3244.468)",
    fill: "#2451aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13710",
    "data-name": "Path 13710",
    d: "M540.617,273.313l.349-1.109a.278.278,0,0,0-.009-.219l-.159.5-.036.044a2.786,2.786,0,0,1-1.43.416l-.348,1.109a2.786,2.786,0,0,0,1.429-.416,1.04,1.04,0,0,0,.2-.329",
    transform: "translate(-4332.403 3239.131)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13711",
    "data-name": "Path 13711",
    d: "M567.683,269.075a2.049,2.049,0,0,1-.691.467l-3.853,1.4c-.935.34-1.506-.772-2.228-1.719l-3.525,1.283c.358-1.045.535-2.222,1.262-2.487l3.853-1.4a1.466,1.466,0,0,1,1.119.156c1.177.549,1.785,2.447,2.744,2.78Z",
    transform: "translate(-4342.471 3247.863)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13712",
    "data-name": "Path 13712",
    d: "M540.467,281.546l-.619.276a.162.162,0,0,0-.092.088l.281-.125h.033c.192,0,.588.31.733.463l.617-.276a1.625,1.625,0,0,0-.733-.463.6.6,0,0,0-.221.038",
    transform: "translate(-4332.294 3240.556)",
    fill: "#dfffd9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13714",
    "data-name": "Path 13714",
    d: "M504.227,320.012a1.047,1.047,0,0,1-.356.241l-1.988.719c-.482.174-.777-.4-1.148-.889l-1.82.659c.187-.538.278-1.147.654-1.282l1.988-.719a.749.749,0,0,1,.577.081c.607.284.919,1.263,1.412,1.436Z",
    transform: "translate(-4337.945 3246.153)",
    fill: "#b0fcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13716",
    "data-name": "Path 13716",
    d: "M527.6,295.451l-2.952.728a2.826,2.826,0,0,1-1.413-.093l2.367-.584a9.1,9.1,0,0,0,.79-1.483l2.952-.728c-.51,1.081-.865,1.944-1.744,2.16",
    transform: "translate(-4334.578 3242.324)",
    fill: "#15d7d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13717",
    "data-name": "Path 13717",
    d: "M540.6,306.758c-.058-.084.088-.672.344-.735l.7-.172c.165-.041.376.139.6.815a2.34,2.34,0,0,1,.1.328l-.7.172a2.3,2.3,0,0,0-.1-.328,2.978,2.978,0,0,0-.229-.534.481.481,0,0,0-.023.282Z",
    transform: "translate(-4332.178 3244.2)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13720",
    "data-name": "Path 13720",
    d: "M512.941,285.213a.88.88,0,0,1,.51-1.377l1.865-.46c.5-.123,1.164.206,1.64,1.538a1.236,1.236,0,0,0,.418.583l1.411-.348a1.363,1.363,0,0,1-.7.495l-1.865.46a.986.986,0,0,1-1.126-.731,3.991,3.991,0,0,0-.433-.889.784.784,0,0,0,.148.268Z",
    transform: "translate(-4336.029 3240.834)",
    fill: "#ffe301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13721",
    "data-name": "Path 13721",
    d: "M529.407,278.32l.385-1.581a.39.39,0,0,1,.169-.257l-.175.719c0,.026.008.053.011.078.074.457.99,1.255,1.412,1.533l-.385,1.582c-.422-.278-1.337-1.077-1.411-1.534a1.452,1.452,0,0,1-.007-.541",
    transform: "translate(-4333.708 3239.807)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13723",
    "data-name": "Path 13723",
    d: "M539.495,281.824a1.276,1.276,0,0,0,.213.462l1.568,1.945c.38.472,1.029.072,1.7-.195l1.434,1.78c.142-.657.421-1.327.125-1.694l-1.567-1.945a.892.892,0,0,0-.633-.271c-.787-.085-1.7.714-2.306.584Z",
    transform: "translate(-4332.342 3240.607)",
    fill: "#97f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13724",
    "data-name": "Path 13724",
    d: "M520.252,306.859l-.96.944a.323.323,0,0,1-.23.105l.436-.428.025-.061a3.226,3.226,0,0,0-.323-1.693l.959-.943a3.223,3.223,0,0,1,.324,1.693,1.222,1.222,0,0,1-.231.383",
    transform: "translate(-4335.139 3244.046)",
    fill: "#2451aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13728",
    "data-name": "Path 13728",
    d: "M526.6,260.71a.736.736,0,0,0,.154.255L527.792,262c.252.251.606-.023.983-.221l.948.95c.041-.393.163-.8-.033-1l-1.036-1.037a.527.527,0,0,0-.386-.119c-.465,0-.948.523-1.31.487Z",
    transform: "translate(-4334.099 3237.422)",
    fill: "#ff7758",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13730",
    "data-name": "Path 13730",
    d: "M474.373,274.619a.8.8,0,0,1-1.134.686l-1.575-.725c-.422-.192-.707-.8-.293-2.008a1.119,1.119,0,0,0,.033-.646l-1.192-.549a1.23,1.23,0,0,1,.775.047l1.575.724a.89.89,0,0,1,.384,1.149,3.579,3.579,0,0,0-.195.87.7.7,0,0,0,.047-.273Z",
    transform: "translate(-4341.812 3239.035)",
    fill: "#97f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13733",
    "data-name": "Path 13733",
    d: "M468.354,291.138l-1.7,1.7a2.235,2.235,0,0,1-1,.515l1.365-1.365a7.228,7.228,0,0,0-.071-1.33l1.7-1.7c.1.943.21,1.672-.3,2.181",
    transform: "translate(-4342.475 3241.678)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13734",
    "data-name": "Path 13734",
    d: "M490.309,313.88a1.346,1.346,0,0,0,.451.307l2.522.917c.612.222.986-.505,1.458-1.126l2.308.84c-.235-.683-.35-1.453-.827-1.628l-2.521-.917a.96.96,0,0,0-.733.1c-.771.36-1.168,1.6-1.8,1.82Z",
    transform: "translate(-4339.141 3245.162)",
    fill: "#dbd638",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13736",
    "data-name": "Path 13736",
    d: "M481.946,286l.761,1.272a1.377,1.377,0,0,1,.158.671l-.609-1.019a4.438,4.438,0,0,0-.805-.157l-.759-1.272c.577.084,1.029.126,1.255.505",
    transform: "translate(-4340.467 3241.154)",
    fill: "#ffe301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13737",
    "data-name": "Path 13737",
    d: "M485.778,302.76c-.1-.044-.292-.668-.093-.867l.544-.544c.129-.129.423-.082,1.01.413a2.542,2.542,0,0,1,.273.246l-.545.544a2.313,2.313,0,0,0-.273-.245,3.169,3.169,0,0,0-.507-.364.507.507,0,0,0,.136.271Z",
    transform: "translate(-4339.785 3243.519)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13738",
    "data-name": "Path 13738",
    d: "M485.871,298.554l-.189.735a.183.183,0,0,1-.08.119l.086-.336-.006-.035c-.032-.214-.455-.591-.649-.724l.188-.735c.2.133.619.51.651.724a.716.716,0,0,1,0,.252",
    transform: "translate(-4339.862 3242.964)",
    fill: "#dbd638",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13739",
    "data-name": "Path 13739",
    d: "M497.8,295.48l-1.135,1.135a1.488,1.488,0,0,1-.664.344l.911-.911a4.663,4.663,0,0,0-.048-.886L498,294.027c.064.629.14,1.114-.2,1.453",
    transform: "translate(-4338.342 3242.434)",
    fill: "#fd0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13741",
    "data-name": "Path 13741",
    d: "M496.867,283.479c-.1-.045-.3-.678-.1-.881l.553-.553c.132-.131.428-.082,1.025.422a2.385,2.385,0,0,1,.277.25l-.553.552a2.479,2.479,0,0,0-.277-.249,3.22,3.22,0,0,0-.515-.37.531.531,0,0,0,.137.276Z",
    transform: "translate(-4338.247 3240.627)",
    fill: "#729690",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13742",
    "data-name": "Path 13742",
    d: "M506.237,304.875a1.113,1.113,0,0,0,.232.388l1.575,1.575c.383.383.919-.033,1.491-.334l1.442,1.442c.063-.6.246-1.218-.052-1.515l-1.575-1.575a.8.8,0,0,0-.586-.18c-.706,0-1.441.795-1.988.739Z",
    transform: "translate(-4336.929 3244.03)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13743",
    "data-name": "Path 13743",
    d: "M481.75,263.324a1.086,1.086,0,0,1-.356.241l-1.99.719c-.482.174-.775-.4-1.146-.889l-1.82.657c.186-.538.277-1.145.653-1.282l1.989-.719a.76.76,0,0,1,.577.081c.606.285.917,1.264,1.412,1.437Z",
    transform: "translate(-4341.061 3237.633)",
    fill: "#b0fcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13747",
    "data-name": "Path 13747",
    d: "M480.057,313.547a.807.807,0,0,0,.252-1.322l-1.245-1.245c-.332-.332-1.01-.391-2.015.43a1.135,1.135,0,0,1-.6.259l-.943-.943a1.254,1.254,0,0,0,.317.723l1.245,1.245a.9.9,0,0,0,1.229-.039,3.641,3.641,0,0,1,.761-.493.7.7,0,0,1-.242.14Z",
    transform: "translate(-4341.166 3244.936)",
    fill: "#dbd638",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13748",
    "data-name": "Path 13748",
    d: "M482.359,272.163l.349-1.109a.286.286,0,0,0-.008-.22l-.159.5-.037.044a2.775,2.775,0,0,1-1.429.416l-.349,1.109a2.786,2.786,0,0,0,1.429-.416,1.027,1.027,0,0,0,.2-.328",
    transform: "translate(-4340.461 3238.913)",
    fill: "#febf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13749",
    "data-name": "Path 13749",
    d: "M481.782,294.246a2.06,2.06,0,0,1-.691.467l-3.853,1.4c-.935.34-1.507-.772-2.228-1.719l-3.525,1.283c.359-1.045.534-2.222,1.262-2.487l3.853-1.4a1.466,1.466,0,0,1,1.119.156c1.177.549,1.784,2.447,2.743,2.78Z",
    transform: "translate(-4341.734 3242.094)",
    fill: "#dbd638",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13750",
    "data-name": "Path 13750",
    d: "M482.209,280.4l-.617.275a.167.167,0,0,0-.093.088l.282-.125h.032a1.625,1.625,0,0,1,.733.463l.617-.276a1.631,1.631,0,0,0-.732-.463.623.623,0,0,0-.222.039",
    transform: "translate(-4340.354 3240.383)",
    fill: "#dfffd9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13751",
    "data-name": "Path 13751",
    d: "M545.824,268.822l.238.931a.235.235,0,0,0,.1.15l-.108-.424.006-.046c.041-.27.576-.748.824-.916l-.238-.931c-.247.167-.782.645-.823.916a.879.879,0,0,0,0,.32",
    transform: "translate(-4331.542 3238.44)",
    fill: "#81dcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13753",
    "data-name": "Path 13753",
    d: "M498.607,267.4l1.248,1.248a1.65,1.65,0,0,0,.731.379l-1-1a5.155,5.155,0,0,1,.053-.975L498.39,265.8c-.072.691-.155,1.226.218,1.6",
    transform: "translate(-4338.02 3238.182)",
    fill: "#b0fcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13754",
    "data-name": "Path 13754",
    d: "M491.714,291.041c-.1-.045-.3-.677-.1-.881l.553-.552c.132-.132.428-.084,1.025.42a2.484,2.484,0,0,1,.277.25l-.553.553a2.294,2.294,0,0,0-.277-.25,3.223,3.223,0,0,0-.515-.37.525.525,0,0,0,.137.276Z",
    transform: "translate(-4338.962 3241.76)",
    fill: "#729690",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10123",
    "data-name": "Rectangle 10123",
    width: 18.622,
    height: 0.759,
    transform: "translate(-3880.294 3548.595)",
    fill: "#0d3f68",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10124",
    "data-name": "Rectangle 10124",
    width: 4.505,
    height: 2.101,
    transform: "translate(-3850.095 3532.42)",
    fill: "#66d0ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirtdaySmall);
export default __webpack_public_path__ + "static/media/birtday-small.8fdcac7c3f186019817d8989377cf8d8.svg";
export { ForwardRef as ReactComponent };